import {
  Updater,
  DataUpdateFunction,
} from 'src/types/queries';

export function functionalUpdate<TData>(
  updater: Updater<TData>,
  input: TData,
): TData {
  return typeof updater === 'function'
    ? (updater as DataUpdateFunction<TData>)(input)
    : updater;
}
